"use client";

import React from "react";
import { ArrowRight, Loader } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function SubscribeFormInner() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-6 border border-gray-800 rounded-sm bg-gray-900/50 text-center h-full flex flex-col justify-center">
        <p className="text-white font-medium">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-4">
      <div className="space-y-2">
        <h3 className="text-xl font-bold text-white">Subscribe</h3>
        <p className="text-gray-400 text-sm">
          Get the latest updates and insights delivered to your inbox.
        </p>
      </div>

      <FormField control={control} name="email" rules={{
      required: "Email is required",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Please enter a valid email address"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="sr-only">Email Address</FormLabel>
            <FormControl>
              <Input type="email" placeholder="Enter your email address" className="border-gray-600 rounded-sm bg-transparent text-white placeholder:text-gray-500 focus-visible:ring-white/20 focus-visible:border-gray-400 h-12" {...field} />
            </FormControl>
            <FormMessage className="text-red-400" />
          </FormItem>} />

      {submitError && <p className="text-red-400 text-sm">{submitError}</p>}

      <Button type="submit" disabled={isSubmitting} className="w-full bg-white text-black hover:bg-gray-200 rounded-sm h-12 font-bold text-base transition-colors">
        {isSubmitting ? <>
            <Loader className="animate-spin mr-2 size-5" />
            Subscribing...
          </> : "Subscribe Now"}
      </Button>
    </Form>;
}
function MediaEnquiryFormInner() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-6 border border-gray-800 rounded-sm bg-gray-900/50 text-center h-full flex flex-col justify-center">
        <p className="text-white font-medium">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-4">
      <div className="space-y-2">
        <h3 className="text-xl font-bold text-white">Media Enquiry</h3>
        <p className="text-gray-400 text-sm">
          For press and media related questions, please reach out.
        </p>
      </div>

      <FormField control={control} name="enquiry" rules={{
      required: "Please enter your enquiry",
      minLength: {
        value: 10,
        message: "Enquiry must be at least 10 characters"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="sr-only">Your Enquiry</FormLabel>
            <FormControl>
              <Input placeholder="Briefly describe your request..." className="border-gray-600 rounded-sm bg-transparent text-white placeholder:text-gray-500 focus-visible:ring-white/20 focus-visible:border-gray-400 h-12" {...field} />
            </FormControl>
            <FormMessage className="text-red-400" />
          </FormItem>} />

      {submitError && <p className="text-red-400 text-sm">{submitError}</p>}

      <div className="flex flex-col sm:flex-row gap-4 items-center">
        <Button type="submit" disabled={isSubmitting} className="w-full sm:w-auto flex-1 bg-white text-black hover:bg-gray-200 rounded-sm h-12 font-bold text-base transition-colors">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-5" />
              Sending...
            </> : "Submit Enquiry"}
        </Button>
        
        <Link to="/MediaCentrePage" className="text-gray-300 hover:text-white text-sm font-medium flex items-center gap-1 transition-colors whitespace-nowrap">
          Visit Media Centre <ArrowRight className="size-4" />
        </Link>
      </div>
    </Form>;
}
export default function SubscribeMediaEnquiry() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="subscribe-media-enquiry" className="bg-black py-20 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        <div ref={ref} className={`transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="text-[32px] font-sans font-bold text-white text-center mb-12 md:mb-16 tracking-tight">
            Subscribe & Media Enquiry
          </h2>

          <div className="grid md:grid-cols-2 gap-8 md:gap-12">
            {}
            <div className={`transition-all duration-700 delay-150 ease-out transform ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
              <div className="p-6 md:p-8 border border-gray-800 rounded-sm bg-gray-950/50 h-full">
                <FormProvider formId="subscribe-newsletter-form" sectionName="Subscribe & Media Enquiry" defaultValues={{
                email: ""
              }} submitText="Subscribe Now" successMessage="Thank you for subscribing!">
                  <SubscribeFormInner />
                </FormProvider>
              </div>
            </div>

            {}
            <div className={`transition-all duration-700 delay-300 ease-out transform ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
              <div className="p-6 md:p-8 border border-gray-800 rounded-sm bg-gray-950/50 h-full">
                <FormProvider formId="media-enquiry-short-form" sectionName="Subscribe & Media Enquiry" defaultValues={{
                enquiry: ""
              }} submitText="Submit Enquiry" successMessage="Your enquiry has been sent. We will be in touch shortly.">
                  <MediaEnquiryFormInner />
                </FormProvider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}